export default __webpack_public_path__ + "static/media/backend.18dd7fec.svg";